import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JWT_STORAGE_KEY_CONFIGURATION_TOKEN } from './tokens';

@NgModule({
  imports: [CommonModule]
})
export class SharedUtilAuthModule {
  static forRoot(localStorageKey: string): ModuleWithProviders<{}> {
    return {
      ngModule: SharedUtilAuthModule,
      providers: [
        {
          provide: JWT_STORAGE_KEY_CONFIGURATION_TOKEN,
          useValue: localStorageKey
        }
      ]
    };
  }
}
